$(function(){

  $(document).ready(function () {

    // ハンバーガーメニュー
    $(".header__menu-btn").on("click", function () {
      $(this).toggleClass("js-open");
      $(".side__menu-wrap").toggleClass("js-open");
      $("body").toggleClass("js-fixed");
    });

    // ハンバーガーメニュー内アコーディオン
    $(".side__menu-btn").on("click", function () {
      $(this).next(".side__menu-list").slideToggle();
      $(this).toggleClass("js-active");
    });
    $(".side__menu-list").hide();

    // 検索ボックス
    $(".header__menu-icon-search").on("click", function () {
      $(".header__search-wrap").fadeToggle();
      $(".header__search-wrap").toggleClass("js-open");
      $(".header__search-input").focus();
    });
    $(".header__search-input-close").on("click", function () {
      $(".header__search-wrap").fadeOut();
      $(".header__search-wrap").removeClass("js-open");
    });
    $(".header__search-wrap").hide();

    // タグ絞り込み
    $(".news__cat-list a").on("click", function () {
      $('.news___link-item').fadeOut('fast');
      var tag_id = $(this).attr('id');
      var tag_ids = '.'+ tag_id;   
      $(tag_ids).fadeIn();
    });

    // パスワードリマインダー
    $(".p_recover a").on("click", function () {
      $('#overlay').fadeIn('');
      $('#recover').fadeIn('');
    });
    

    
    // ページトップ
    $('.footer__pagetop-wrap').hide();
    $(window).on('scroll', function() {
      if ($(this).scrollTop() > 0) {
          $('.footer__pagetop-wrap').fadeIn();
      } else {
          $('.footer__pagetop-wrap').fadeOut();
      }
    });

    // ページ内スクロール
    $('a[href*="#"]').click(function () {
      var headerHight = 100;
      var speed = 500;
      var href = $(this).attr('href').split("#").slice(-1);
      var target = $(href == "#" || href == "" ? 'html' : '#' + href);
      var position = target.offset().top - headerHight;
      var w = $(window).width();
      if (w <= 734) {
        headerHight = 40;
      }
      $("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      return false;
    });

    // フッターアコーディオン
    $(".footer__link-btn").on("click", function () {
      $(this).next(".footer__nest-list").slideToggle();
      $(this).toggleClass("js-active");
    });
    $(".footer__nest-list").hide();

    // 認証チェックボタン
    $('#apon').removeAttr('checked').prop('checked', false).change();
    $('#apon').click(function () {
      $('.no_approval').slideToggle();
    });

    // TOP タブ切り替え
    $(".search__tab-btn").on("click", function () {
      let index = $(".search__tab-btn").index(this);
      $(".search__tab-btn").removeClass("js-active");
      $(this).addClass("js-active");
      $(".search__link-block").hide().eq(index).fadeIn();
    });
    $(".search__tab-btn").first().addClass("js-active");
    $(".search__link-block").hide().first().show();

    // TOP 遷移
    var urlHash = location.hash;
    if (urlHash) {
      if (urlHash == '#p_kind') {
        $(".search__tab-btn").removeClass("js-active");
        $(".search__tab-btn").eq(0).addClass("js-active");
        $(".search__link-block").hide();
        $(".search__link-block").hide().eq(0).fadeIn();
      } else if (urlHash == '#p_component') {
        $(".search__tab-btn").removeClass("js-active");
        $(".search__tab-btn").eq(1).addClass("js-active");
        $(".search__link-block").hide();
        $(".search__link-block").hide().eq(1).fadeIn();
      } else if (urlHash == '#p_symptom') {
        $(".search__tab-btn").removeClass("js-active");
        $(".search__tab-btn").eq(2).addClass("js-active");
        $(".search__link-block").hide();
        $(".search__link-block").hide().eq(2).fadeIn();
      }
    }
    
    // Brand MORE
    $(".b_more").on("click", function () {
      $(".brand_more").fadeIn();
      $(".brand_more").slideDown("slow");
      $(".b_more").fadeOut();
    });

  });


  // スライダー
  if(window.matchMedia("(min-width:769px)").matches){
    $(".item__list-slide").slick({
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      autoplay: true,
      prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0767/6991/9260/files/search_link_arr.png" class="slide__arrow slide__arrow-prev">',
      nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0767/6991/9260/files/search_link_arr.png" class="slide__arrow slide__arrow-next">'
    });
  }else{
  }

    // 商品詳細トップ部分のスライダー
  $(".itemdetail__img-slide")
  .on("init", function (event, slick) {
    $(this).append('<div class="slick__num"><span class="now__count"></span> / <span class="all__count"></span></div>');
    $(".now__count").text(slick.currentSlide + 1); 
    $(".all__count").text(slick.slideCount);
  })
  .slick({
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0767/6991/9260/files/search_link_arr.png" class="slide__arrow slide__arrow-prev">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0767/6991/9260/files/search_link_arr.png" class="slide__arrow slide__arrow-next">',
    responsive: [
      {
        breakpoint: 789,
        settings: {
          prevArrow: '<p class="slide__arrow slide__arrow-prev"><</p>',
          nextArrow: '<p class="slide__arrow slide__arrow-next">></p>',
        },
      },
    ],
  })
  .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    $(".now__count").text(nextSlide + 1);
  });

});


